import * as React from 'react';

import { ActivityType } from '@showbie-socrative/socrative-utils';
import { useSelector } from 'react-redux';

import { ActivityResultBlankResults } from '~teacher/components/ActivityResult/States/ActivityResultBlankResults';
import { ActivityResultError } from '~teacher/components/ActivityResult/States/ActivityResultError';
import { ActivityResultLoading } from '~teacher/components/ActivityResult/States/ActivityResultLoading';
import { useSocrativeRouter } from '~teacher/context/RouterContext';
import { useActivityByCurrentRoom } from '~teacher/hook';
import { selectCurrentRoomId } from '~teacher/slices/teacher/teacherSelector';

function ActivityLivePage() {
  const router = useSocrativeRouter();
  const roomId = useSelector(selectCurrentRoomId);
  const { data, isLoading, isError, isStale } = useActivityByCurrentRoom(
    roomId,
    window.pubnub
  );
  const activityId = data?.activity?.id;

  // If live activity found, redirect
  React.useEffect(() => {
    if (isStale || !data || !activityId) return;

    if (data?.activity?.activityType === ActivityType.SpaceRace) {
      // Route to legacy code for now, until refactored
      router.routeToSpaceRace(true);
    } else {
      router.navigate(`results/${activityId}`, {
        trigger: true,
        replace: true,
      });
    }
  }, [data, activityId, isStale, router]);

  if (isError) {
    return <ActivityResultError />;
  }

  if (!isLoading && !activityId) {
    return (
      <div className="flex justify-center">
        <ActivityResultBlankResults />
      </div>
    );
  }

  return <ActivityResultLoading />;
}

export { ActivityLivePage };
